module.exports = __webpack_public_path__ + "img/avatar.2e825e55.jpg";